export default {
	appEnv: "production",
	apiUrl: "https://chatbot-api.getvirtualbrain.com",
	sentryDsn:
		"https://8b2b07c495b81bac3e31f56374bb6316@o4505295141535744.ingest.sentry.io/4506002590334976",
	version: "v2026.11.05.2",
};
